import React from 'react';
import styled from "styled-components";

export const HowItWorksTitle = ({
  text,
  maxWidth,
  marginBottom,
  parentName,
}) => (
  <HomeTitleStyled className={`title__${parentName}`} maxWidth={maxWidth} marginBottom={marginBottom}>
    {text}
  </HomeTitleStyled>
);

export const HomeTitleStyled = styled.h2`
  max-width: ${props => props.maxWidth.desktop};
  overflow: visible;
  font-style: normal;
  font-weight: normal;
  font-size: 50px;
  line-height: 50px;
   color: #19222D;
  letter-spacing: -1.3px;
  text-align: center;
  margin: 0 auto ${props => props.marginBottom.desktop};
  
  &.title__slider {
    margin-bottom: 43px;

    @media (max-width: 1024px) {
      margin-bottom: 22px;
    }
  }
  
   @media (max-width: 1024px) {
        margin: 0 auto ${props => props.marginBottom.mobile};
        margin: 0 auto ${props => props.marginBottom.mobile};
        font-size: 30px;
        line-height: 30px;
        text-align: center;
        letter-spacing: -0.03em;
        padding: 0 20px;  
        
        &.title__marketplace {
          padding: 0 10px;
          max-width: 360px;
        }
        &.title__process {
          font-size: 36px;
          line-height: 36px;
        }
      }
  `;
